import type { AppConfigInput } from 'nuxt/schema'

export default defineAppConfig({
  awesome: {
    name: '玻色量子 - 专用量子计算机 | 国际领先的量子计算技术',
    description: '这是一个官网',
    // project: {
    //   links: {
    //     github: 'https://www.qboson.com/',
    //   },
    // },
    layout: {
      page: {
        navbar: {
          menus: [
            {
              type: 'link',
              title: '硬件产品',
              to: {
                name: 'product',
              },
            },
            {
              type: 'dropdown',
              title: '生态解决方案',
              children: [
                {
                  type: 'link',
                  title: '生物与材料',
                  to: { name: 'biopharmaceutical' },
                },
                {
                  type: 'link',
                  title: '人工智能',
                  to: { name: 'AI' },
                },
                {
                  type: 'link',
                  title: '数字城市',
                  to: { name: 'city' },
                },
              ],
            },
            {
              type: 'link',
              title: '开物开发者社区',
              to: 'https://kaiwu.qboson.com/',
            },
            {
              type: 'link',
              title: '量子云',
              to: 'https://cloud.qboson.com/',
            },
            { type: 'link', title: '关于玻色', to: { name: 'about' } },
            {
              type: 'dropdown',
              title: '加入我们',
              children: [
                {
                  type: 'link',
                  title: '校招职位',
                  to: 'https://app.mokahr.com/campus-recruitment/boseq/140969?locale=zh-CN',
                },
                {
                  type: 'link',
                  title: '社招职位',
                  to: 'https://app.mokahr.com/social-recruitment/boseq/140968?locale=zh-CN',
                },
              ],
            },
            { type: 'link', title: '企业新闻', to: { name: 'news-v2' } },
            // dynamic title
            // {
            //   type: 'button',
            //   title: (nuxt) =>
            //     (nuxt._appConfig as AppConfigInput)?.awesome?.name || '',
            //   to: (nuxt) => (nuxt._appConfig as AppConfigInput)?.awesome?.name || '',
            // },
          ],
        },
      },
      footer: {
        year: new Date().getFullYear(),
      },
    },
  },
})
